export default __webpack_public_path__ + "static/media/secure-icon.0387d82d.png";